Cookies = {
    setItem(cname, cvalue, exdays = 90){
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        const secure = window.location.protocol === "https:" ? "; Secure" : "";
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=Lax" + secure;
    },
    getItem(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }
}

window.Cookies = Cookies;
